import React, { ReactNode } from 'react'

import { Icon } from '../../../atoms'
import { IconName } from '../../../atoms/icons/icon'

export type QuoteEmptyStateProps = {
  icon: IconName
  description: ReactNode
}

const QuoteEmptyState = ({ icon, description }: QuoteEmptyStateProps) => {
  return (
    <div className='flex h-full flex-col items-center justify-center gap-3'>
      <Icon name={icon} size={80} color='#CFD2D6' />
      <div className='max-w-[400px] text-center text-grey-700'>
        {description}
      </div>
    </div>
  )
}

export default QuoteEmptyState
